import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { ReportProvider } from '../../providers/report/report';


@IonicPage()
@Component({
  selector: 'page-report-global',
  templateUrl: 'report-global.html',
})
export class ReportGlobalPage {

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public reportProvider: ReportProvider,
  ) {}

  generate() {
    // Mostrar loading
    let loading = this.loadingCtrl.create({
      content: 'Generando PDF...'
    });

    loading.present();
    
    this.reportProvider.globalReport()
      .then(() => loading.dismiss())
      .catch(error => { console.log(error); loading.dismiss() })
  }
}


// WEBPACK FOOTER //
// ./src/pages/report-global/report-global.ts